<template>
  <div class="widget">
    <div class="top">
      <div class="place-time">
        <div class="place">
          {{ getTitle('weather.city') }}{{ getTitle('weather.NT') }}
        </div>
        <div class="time">{{ `${weatherData.future[0].date}` }}</div>
      </div>
      <div class="real-weather">
        <div class="temp">
          <span>{{ weatherData.realtime.temperature }}</span>
          <p>℃<br />{{ getTitle('weather.Now') }}</p>
        </div>
        <div class="today">
          <div>
            <p>
              {{ getTitle('weather.info.' + weatherData.realtime.info) }} |
              {{ weatherData.future[0].temperature.replace('/', '~') }}
            </p>
            <p>
              {{ getTitle('weather.direct.' + weatherData.realtime.direct) }}
              {{ getTitle('weather.power.' + weatherData.realtime.power) }}
              <span
                class="aqi"
                v-show="aqi && aqi != ' '"
                :style="`background: ${aqi_color}`"
                >{{ getTitle('weather.aqi.' + aqi) }}</span
              >
            </p>
          </div>
          <span class="icon iconfont base-color" :class="wid.icon"></span>
        </div>
      </div>
      <ul class="weekly-weather">
        <li v-for="item in weatherList" :key="item.index">
          <p>{{ item.date }}</p>
          <p>
            <span
              class="icon iconfont base-color"
              :class="widIcons[item.wid.day]"
              :title="widWeather[item.wid.day]"
            ></span>
          </p>
          <p>{{ item.temperature.replace('/', '~') }}</p>
        </li>
      </ul>
    </div>
    <div class="center">
      <div class="amount">
        <h3>{{ getTitle('weather.RTVV') }}</h3>
        <div class="number">
          <span v-for="(item, index) in queryRealtimeCurrent" :key="index">{{
            item
          }}</span>
        </div>
      </div>
      <div class="amount">
        <h3>{{ getTitle('weather.PSA') }}</h3>
        <div class="number">
          <span v-for="(item, index) in parkingInfoRest" :key="index">{{
            item
          }}</span>
        </div>
      </div>
      <div class="amount">
        <h3>{{ getTitle('weather.MBC') }}</h3>
        <div class="number">
          <span v-for="(item, index) in queryRealtimeMaxLoad" :key="index">{{
            item
          }}</span>
        </div>
      </div>
      <div class="amount">
        <h3>{{ getTitle('weather.IMBC') }}</h3>
        <div class="number">
          <span
            v-for="(item, index) in queryRealtimeMaxRealtimeLoad"
            :key="index"
            >{{ item }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import { widResult, aqiResult, widIcons, widWeather } from './dataConfig';
import { preZeroFill } from '@/setup/common';
import _ from 'underscore';
export default {
  components: {},
  data() {
    return {
      city: '敦化',
      week: '',
      aqi: '', //空气质量指数
      wid: {}, //天气标识id
      aqi_color: '',
      weatherList: [],
      widIcons,
      widWeather,
      queryRealtimeCurrent: [],
      queryRealtimeMaxLoad: [],
      queryRealtimeMaxRealtimeLoad: [],
      parkingInfoRest: [],
      maxNum: 5,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    weatherData() {
      return this.$store.state.overview.weatherData;
    },
  },
  async mounted() {
    await this.getApi();
    await this.dataBuild();
    await this.getQueryRealtime();
    await this.getParkingInfo();
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
  },
  methods: {
    async dataBuild() {
      try {
        if (!this.weatherData) {
          return;
        }
        this.week = this.getWeek(this.weatherData.future[0].date);
        let current_aqi = _.find(aqiResult, (cur) => {
          return (
            this.weatherData.realtime.aqi >= cur.aqi[0] &&
            this.weatherData.realtime.aqi <= cur.aqi[1]
          );
        });
        this.aqi = current_aqi.text;
        this.aqi_color = current_aqi.color;
        this.wid = _.find(widResult, (cur) => {
          return cur.wid == this.weatherData.realtime.wid;
        });
        this.weatherList = this.weatherData.future;
      } catch (e) {
        console.log(e);
      }
    },
    getApi: async function() {
      await this.$store.dispatch('handleWeatherInfo', { city: this.city });
    },
    /** 根据日期字符串获取星期几
     * @param dateString 日期字符串（如：2020-05-02）
     * @returns {String}*/
    getWeek(dateString) {
      var dateArray = dateString.split('-');
      var date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2],
      );
      return '星期' + '日一二三四五六'.charAt(date.getDay());
    },
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async getQueryRealtime() {
      const getQueryRealtime = await www.getQueryRealtime();
      this.queryRealtime = getQueryRealtime;
      this.queryRealtimeCurrent = preZeroFill(
        getQueryRealtime.current,
        this.maxNum,
      ).split('');
      this.queryRealtimeMaxLoad = preZeroFill(
        getQueryRealtime.max_load,
        this.maxNum,
      ).split('');
      this.queryRealtimeMaxRealtimeLoad = preZeroFill(
        getQueryRealtime.max_realtime_load,
        this.maxNum,
      ).split('');
    },
    async getParkingInfo() {
      const getParkingInfo = await www.getParkingInfo();
      this.parkingInfo = getParkingInfo;
      this.parkingInfoRest = preZeroFill(
        getParkingInfo.rest,
        this.maxNum,
      ).split('');
    },
  },
};
</script>

<style lang="less" scoped>
.widget {
  width: 460px;
  position: absolute;
  top: 70px;
  left: 56%;
  z-index: 20;
  .top {
    padding: 30px 30px 20px;
    border-radius: 10px 10px 0 0;
    background: rgba(255, 255, 255, 1);
    .place-time {
      display: flex;
      justify-content: space-between;
      margin-bottom: 22px;
      font-weight: bold;
      font-size: 20px;
      .time {
        font-size: 16px;
      }
    }
    .real-weather {
      display: flex;
      margin-bottom: 10px;
      .temp {
        display: flex;
        width: 120px;
        margin-right: 30px;
        padding-right: 0;
        border-right: 1px solid rgba(81, 84, 87, 0.3);
        line-height: 25px;
        text-align: left;
        span {
          padding-right: 10px;
          color: #31a775;
          font-weight: bold;
          font-size: 46px;
          line-height: 50px;
        }
      }
      .today {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 250px;
        line-height: 25px;
        text-align: left;
        .aqi {
          display: inline-block;
          margin-left: 2px;
          padding: 0px 10px 0 9px;
          border-radius: 5px;
          color: #fff;
        }
        .icon {
          color: #31a775;
          font-size: 50px;
          line-height: 50px;
        }
      }
    }
    .weekly-weather {
      display: flex;
      justify-content: space-between;
      color: #515457;
      text-align: center;
      .icon {
        display: block;
        padding: 5px 0;
        color: #31a775;
        font-size: 40px;
        line-height: 40px;
      }
    }
  }
  .center {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 13px 0 17px;
    border-radius: 0 0 10px 10px;
    background: rgba(255, 255, 255, 0.9);
    .amount {
      width: 180px;
      margin: 12px 20px;
      text-align: center;
      h3 {
        margin-bottom: 10px;
        font-size: 16px;
      }
      .number {
        display: flex;
        justify-content: center;
        span {
          margin: 0 3px;
          padding: 10px 5px;
          position: relative;
          border-radius: 4px;
          color: #fff;
          font-weight: 500;
          font-size: 26px;
          background: rgba(49, 167, 117, 0.9);
        }
        i {
          height: 1px;
          position: absolute;
          top: 50%;
          right: 0;
          left: 0;
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }
}
.border-left {
  border-left: 1px solid rgba(104, 217, 252, 0.2);
}
.wt-header {
  padding: 10px 5px 5px;
  color: #fff;
}
.details {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  p {
    line-height: 22px;
  }
  /deep/.ivu-tag {
    height: 18px;
    margin-top: 5px;
    border-width: 0;
    line-height: 18px;
    vertical-align: text-bottom;
    span {
      color: #fff;
    }
    &.green {
      background-color: #40c157;
    }
  }
}
</style>
